import React from "react";

const TermsandConditions = () => (
  <div
    style={{ minHeight: "100vh", background: "#050A18", padding: "0 0 48px 0" }}
  >
    <div
      style={{
        background: "#111827",
        color: "#fff",
        padding: "56px 0 36px 0",
        textAlign: "center",
      }}
    >
      <div className="text-3xl font-bold tracking-wide text-center mb-2">
        <h2>
          {" "}
          <span className="text-[#4FA0FF]">Terms and</span>{" "}
          <span className="text-white">Conditions</span>
        </h2>
      </div>

      <p style={{ fontSize: "1.1rem", marginTop: 12, color: "white" }}>
        Please read these terms carefully before using our services.
      </p>
    </div>

    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        background: "#111827",
        borderRadius: 16,
        boxShadow: "0 4px 24px 0 rgba(79, 160, 255, 0.1)",
        padding: "40px 28px",
        color: "#1D3557",
        fontSize: "1.08rem",
        lineHeight: 1.7,
        border: "1px solid gray",
      }}
    >
      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          1. Introduction
        </h2>
        <p className="text-gray-300">
          By accessing and using the Kubermax platform, you agree to be bound by
          the terms and conditions outlined herein. These terms govern your use
          of our loan services and associated features.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          2. Intellectual Property
        </h2>
        <p className="text-gray-300">
          All content, trademarks, graphics, designs, and materials on this site
          are the intellectual property of Kubermax and are protected by
          applicable copyright and trademark laws.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          3. User Responsibilities
        </h2>
        <p className="text-gray-300">
          You are responsible for maintaining the confidentiality of your
          account credentials and agree to accept responsibility for all
          activities that occur under your account. Misuse or unauthorized use
          of your account may result in suspension or legal action.
        </p>
      </section>

      <section style={{ marginBottom: 32 }}>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          4. Limitation of Liability
        </h2>
        <p className="text-gray-300">
          Kubermax is not liable for any direct or indirect damages arising from
          the use or inability to use our platform or services, including but
          not limited to financial loss, data breaches, or technical
          disruptions.
        </p>
      </section>

      <section>
        <h2
          style={{
            fontSize: "1.3rem",
            fontWeight: 700,
            marginBottom: 12,
            color: "#4FA0FF",
          }}
        >
          5. Changes to Terms
        </h2>
        <p className="text-gray-300">
          Kubermax reserves the right to update or modify these terms at any
          time without prior notice. Continued use of the platform after such
          changes signifies your acceptance of the updated terms.
        </p>
      </section>
    </div>
  </div>
);

export default TermsandConditions;